import React from 'react'
import SeccionNormatividad from '../../componentes/panel-institucion/SeccionNormatividad'

interface PaginaNormativaGeneralProps {
  basePath: string
}

const PaginaNormativaGeneral: React.FC<PaginaNormativaGeneralProps> = ({ basePath }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Normatividad y Legislación</h1>
        <p className="mt-1 text-gray-500 dark:text-gray-400">
          Accede a toda la base legal, reglamentos y tratados relacionados con el comercio exterior.
        </p>
      </div>

      <SeccionNormatividad basePath={basePath} />
    </div>
  )
}

export default PaginaNormativaGeneral
